import { render } from "./__OK__Meals.vue?vue&type=template&id=26a71e9a"
import script from "./__OK__Meals.vue?vue&type=script&lang=js"
export * from "./__OK__Meals.vue?vue&type=script&lang=js"

import "./__OK__Meals.vue?vue&type=style&index=0&id=26a71e9a&lang=css"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__